import { styled } from "@vitality-ds/system";
import BaseItemIconStyles from "./styles/BaseItemIcon.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDropdownMenuItemIcon = styled("span", BaseItemIconStyles);